'use client'

import { ReactNode } from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import { mtc, TypographyStyles } from '../../../utils/style-helpers'
import { Text } from '../text'
import { optionalTextStyles, titleStyles } from './styles'
import { Popup } from '../../molecules'

export interface ILabelProps extends LabelPrimitive.LabelProps {
  children?: ReactNode
  className?: string
  disabled?: boolean
  error?: boolean
  optionalText?: string
  title?: string
  popupContent?: ReactNode
}

export const Label = ({
  children,
  className,
  disabled,
  error,
  optionalText,
  title,
  popupContent,
  ...props
}: ILabelProps) => {
  return (
    <LabelPrimitive.Root className={mtc(className)} {...props}>
      {(title || optionalText) && (
        <div>
          {popupContent ? (
            <Popup
              content={popupContent}
              trigger={
                <Text
                  className={mtc(titleStyles({ error, disabled }))}
                  variant={TypographyStyles.LABEL_SM}
                  underlined
                >
                  {title}
                </Text>
              }
            />
          ) : (
            <Text
              className={mtc(titleStyles({ error, disabled }))}
              variant={TypographyStyles.LABEL_SM}
            >
              {title}
            </Text>
          )}

          {optionalText && (
            <Text
              className={mtc(optionalTextStyles({ error, disabled }))}
              variant={TypographyStyles.BODY_XS}
            >
              {optionalText}
            </Text>
          )}
        </div>
      )}

      {children}
    </LabelPrimitive.Root>
  )
}

Label.displayName = LabelPrimitive.Root.displayName
